import { render, staticRenderFns } from "./editRouterPanel.vue?vue&type=template&id=09973915&scoped=true&"
import script from "./editRouterPanel.vue?vue&type=script&lang=js&"
export * from "./editRouterPanel.vue?vue&type=script&lang=js&"
import style0 from "./editRouterPanel.vue?vue&type=style&index=0&id=09973915&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09973915",
  null
  
)

export default component.exports